module.exports = __webpack_public_path__ + "static/img/Aboutus.4ac8f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/Aboutus.png
// module id = gEYs
// module chunks = 1